import React, {
	useEffect, useLayoutEffect, useRef, useState,
} from 'react';

const drawChart = (canvasRef, data, labels) => () => {
	const canvas = canvasRef.current;
	const ctx = canvas.getContext('2d');
	const height = canvas.clientHeight;
	const width = canvas.clientWidth;

	const xAxisHeight = height - 20;

	const maxValue = Math.max(...data);
	const normalizedData = data.map((v) => (Math.floor((v * (xAxisHeight - 20)) / maxValue)));


	ctx.beginPath();
	ctx.moveTo(0, 0);
	ctx.lineTo(0, xAxisHeight);
	ctx.lineTo(width, xAxisHeight);
	ctx.stroke();

	const barWidth = Math.floor(width / (normalizedData.length * 2 + 1));

	normalizedData.forEach((v, i) => {
		const barLeft = barWidth * (i * 2 + 1);
		const { width: valueTextWidth } = ctx.measureText(data[i]);
		ctx.fillText(data[i], barLeft + (barWidth - valueTextWidth) / 2, xAxisHeight - v - 10);
		ctx.fillRect(barLeft, xAxisHeight - v, barWidth, v);
		if (labels[i]) {
			const { width: labelTextWidth } = ctx.measureText(labels[i]);
			ctx.fillText(
				labels[i],
				barLeft + (barWidth - labelTextWidth) / 2,
				xAxisHeight + 10,
			);
		}
	});
};

const SMeter = ({
	data = [],
	labels = [],
	style = {},
	title,
}) => {
	const canvasRef = useRef();
	const containerDivRef = useRef();
	const [dimensions, setDimensions] = useState([150, 100]);

	useLayoutEffect(() => {
		const container = containerDivRef.current;
		if (!container) { return; }
		setDimensions([(data.length * 2 + 1) * 5, container.clientHeight]);
	}, [data]);

	useEffect(() => {
		const container = containerDivRef.current;
		if (!container) { return; }
		if (container.clientWidth !== dimensions[0] || container.clientHeight !== dimensions[1]) {
			setDimensions([container.clientWidth, container.clientHeight]);
		}
		const canvas = canvasRef.current;
		const ctx = canvas.getContext('2d');
		drawChart(canvasRef, data, labels)();
		// eslint-disable-next-line consistent-return
		return (() => {
			ctx.clearRect(0, 0, dimensions[0], dimensions[1]);
		});
	}, [data, labels, dimensions]);

	return (
		<div style={({
			flex: 1, display: 'flex', flexDirection: 'column', ...style,
		})}
		>
			{title ? <div style={{ textAlign: 'center' }}>{title}</div>	: null}
			<div style={{ display: 'flex', flexDirection: 'row', flex: 1 }} ref={containerDivRef}>
				<canvas width={dimensions[0]} height={dimensions[1]} ref={canvasRef} />
			</div>
		</div>
	);
};

export default SMeter;
